import { usePermissionCheck } from '../hooks/usePermissionCheck';
import { DashboardViewProvider, resourceAdminId, useDashboardView } from '../components/admin-dashboard/DashboardViewToggle';
import ControlCentreDashboard from './ControlCentreDashboard';
import ResourceControlCentre from './ResourceControlCentre';

/**
 * Home route (/admin-dashboard). Crew see their own dashboard. Admins see the
 * business control centre. A crew member who is also an admin can switch, and
 * the last choice is the one that opens next time.
 */
export default function AdminDashboard() {
  const { isLoading, canViewAdminDashboard, currentResource } = usePermissionCheck();
  const adminResourceId = resourceAdminId(currentResource);

  if (isLoading) {
    return <div className="control-centre min-h-[40vh]" />;
  }

  return (
    <DashboardViewProvider resourceId={canViewAdminDashboard ? adminResourceId : null}>
      <DashboardHome canViewAdminDashboard={canViewAdminDashboard} />
    </DashboardViewProvider>
  );
}

function DashboardHome({ canViewAdminDashboard }: { canViewAdminDashboard: boolean }) {
  const { canToggle, view } = useDashboardView();
  if (!canViewAdminDashboard || (canToggle && view === 'resource')) {
    return <ResourceControlCentre />;
  }
  return <ControlCentreDashboard />;
}
